import AppConfig from './app-config';

// Shared helpers for multi-tower unit handling.
// Tower names are LITERAL PREFIXES matching the unit string exactly (e.g. "T1-704").

export function isMultiTowerEnabled() {
    // AppConfig.getLocal returns a boolean for "true"/"false" strings.
    return AppConfig.getLocal('multi_tower_enabled') === true;
}

export function getTowers() {
    const raw = AppConfig.getLocal('multi_tower_towers');
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.filter((t) => String(t).length > 0);
    return String(raw).split(',').map((t) => t.trim()).filter((t) => t.length > 0);
}

export function composeUnit(tower, apt) {
    if (!tower) return apt || '';
    if (!apt) return '';
    return `${tower}-${apt}`;
}

export function parseTower(unit) {
    if (!unit || typeof unit !== 'string') return null;
    if (!unit.includes('-')) return null;
    return unit.split('-', 1)[0];
}

// validateUnit composes the multi-tower gate (when enabled) with the existing
// unit_regex gate. Returns { valid: boolean, error: string }.
export function validateUnit(unit, unitRegex) {
    if (!unit || !String(unit).trim()) {
        return { valid: false, error: 'Ingrese la unidad.' };
    }
    const trimmed = String(unit).trim();
    if (isMultiTowerEnabled()) {
        const towers = getTowers();
        if (towers.length > 0) {
            const tower = parseTower(trimmed);
            if (!tower) {
                return { valid: false, error: 'La unidad debe incluir el prefijo de torre (ej. T1-704).' };
            }
            if (!towers.includes(tower)) {
                return { valid: false, error: `Torre inválida. Torres válidas: ${towers.join(', ')}.` };
            }
        }
    }
    if (unitRegex) {
        const regex = new RegExp(`^${unitRegex}$`);
        if (!regex.test(trimmed)) {
            const sample = AppConfig.getLocal('unit_sample');
            return { valid: false, error: `Formato inválido. Ejemplo: ${sample || unitRegex}` };
        }
    }
    return { valid: true, error: '' };
}

export default { isMultiTowerEnabled, getTowers, composeUnit, parseTower, validateUnit };
